<app-data-list
  [data]="data"
  [loading]="loadingData"
  [columns]="columns"
  [rowCls]="rowCls"
  [rowUrl]="'/admin/invoices/'"
  [orderBy]="orderBy"
  (updatedOrderBy)="updatedOrderBy($event)"
  (prevPage)="prevPage()"
  (nextPage)="nextPage()"
  [currentPage]="currentPage"
    [rightBtns]="[
        {
            label: 'GENERAL.ADD',
            icon: faPlus,
            options: addInvoiceDropdownOptions
        }
    ]"
></app-data-list>

<div
  class="modal fade"
  id="invoice-request-modal"
  tabindex="-1"
  aria-labelledby="invoice-request-modalLabel"
  aria-hidden="true"
  #modalInvoiceRequest
  >
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        @if (requestedInvoiceType === EnumInvoiceType.definitive) {
          <h5
            class="modal-title"
            [innerText]="'INVOICE.REQUEST_DEFINITIVE' | translate"
          ></h5>
        }
        @if (requestedInvoiceType === EnumInvoiceType.creditNote) {
          <h5
            class="modal-title"
            [innerText]="'INVOICE.REQUEST_CREDIT_NOTE' | translate"
          ></h5>
        }
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'GENERAL.CLOSE' | translate"
          #btnCloseModal
        ></button>
      </div>

      <div class="list-group list-group-flush">
        @for (invoice of invoicesOptionsForRequest; track invoice) {
          <a
            [routerLink]="'/admin/send-emails/invoice-requested/' + invoice.id"
            class="list-group-item list-group-item-action"
            data-bs-dismiss="modal"
            >
            <div class="row align-items-center">
              <div class="col text-start">
                {{ invoice.ref }}<br />
                {{ invoice.invoiceObject }}<br />
                {{ formatPrice(invoice.amountTtcTotal, invoice.currency) }}
              </div>
              <div class="col text-end">
                <fa-icon [icon]="faArrowRight"></fa-icon>
              </div>
            </div>
          </a>
        }
        <button
          type="button"
          (click)="requestInvoiceFromZero(requestedInvoiceType)"
          class="list-group-item list-group-item-action text-center"
          data-bs-dismiss="modal"
          >
          <div class="row align-items-center">
            <div class="col text-start">
              {{ "INVOICE.REQUEST_FOR_NEW_ONE" | translate }}
            </div>
            <div class="col text-end">
              <fa-icon [icon]="faArrowRight"></fa-icon>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
